jQuery(function ($) {
  const header                = $('[data-header]');
  const navigation            = header.find('.header-navigation');
  const submenus              = header.find('[data-submenu]');
  const submenuCloneContainer = header.find('[data-submenu-clones]');

  let isOpen = false;

  // clone submenus for mobile nav
  submenuCloneContainer.html(submenus.clone());

  const submenuClones = submenuCloneContainer.find('[data-submenu]');

  $(window).on('scroll', function () {
    if (window.pageYOffset > 0) {
      header.addClass('is-sticky');
    } else {
      header.removeClass('is-sticky');
    }
  });

  $('[data-header-toggle]').on('click', function () {
    if (isOpen === false) {
      isOpen = true;
      header.addClass('is-open');

      bodyScrollLock.disableBodyScroll(navigation[0]);
    } else {
      isOpen = false;
      header.removeClass('is-open');
      submenuClones.removeClass('is-open');

      bodyScrollLock.enableBodyScroll(navigation[0]);
    }
  });

  header.on('mouseenter focusin', function () {
    header.addClass('is-open');
  });

  header.on('mouseleave focusout', function () {
    header.removeClass('is-open');
    header.find(':focus').blur();
  });

  // check on pageload if header is hovered
  if (header.is(':hover')) {
    header.addClass('is-open');
  }

  header.find('.headerNav-item').on('mouseenter', function (e) {
    // blur current hover so clicked elements don't remain with :focus-within styles
    document.activeElement.blur();
    header.addClass('is-open');
  });

  // check on pageload (if site was loaded with anchorlink)
  if (window.scrollY > 0) {
    header.addClass('is-sticky');
  } else {
    header.removeClass('is-sticky');
  }

  navigation.find('[data-submenu-toggle]').on('click', function () {
    const submenu = submenuClones.filter('[data-submenu="' + $(this).data('submenuToggle') + '"]');

    submenu.addClass('is-open');

    bodyScrollLock.clearAllBodyScrollLocks();
    bodyScrollLock.enableBodyScroll(submenu[0]);
  });

  submenuClones.find('[data-submenu-back]').on('click', function () {
    $(this).parents('[data-submenu]').removeClass('is-open');

    bodyScrollLock.clearAllBodyScrollLocks();
    bodyScrollLock.enableBodyScroll(navigation[0]);
  });
});
